import Link from "next/link"
import styles from "./slide-link.module.scss"

const LocationListSlide = ({ data = [], viewAllLocationText, viewAllLocationLink, onClickOpenSheet, ...props }) => {
  return (
    <>
      <section className={`${props.className} ${styles.locationList} flex`}>
        <div className={`${styles.itemList} flex`}>
          {data.map(({ title, href }, i) => {
            return (
              <Link href={href} key={i} prefetch={false}>
                <a className={`${styles.item} inlineFlex`}>{title}</a>
              </Link>
            )
          })}
          {!!viewAllLocationText && viewAllLocationLink ? (
            <Link href={viewAllLocationLink} className={"inlineFlex"}>
              <a className={`${styles.item} inlineFlex`}>{viewAllLocationText}</a>
            </Link>
          ) : null}
        </div>
      </section>
    </>
  )
}

export default LocationListSlide
